import {API} from 'aws-amplify';

export * from './host';

export const read = async () => API.get('eventmanagerAdminApi', '/events', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/events/${id}`, {});

export const removeGuest = async (id, eventGuestId) =>
  API.del('eventmanagerAdminApi', `/events/${id}/guests/${eventGuestId}`, {});

export const addGuests = async (id, guests) =>
  API.put('eventmanagerAdminApi', `/events/${id}/guests`, {body: {guests}});

export const updateGuest = async (id, guest) =>
  API.post('eventmanagerAdminApi', `/events/${id}/guests/${guest.id}`, {body: {guest}});

export const readGuests = async (id) => API.get('eventmanagerAdminApi', `/events/${id}/guests`, {});

export const readTemplates = async (id) => API.get('eventmanagerAdminApi', `/events/${id}/templates`, {});

export const createTemplate = async (id, template) => API.put('eventmanagerAdminApi', `/events/${id}/templates`,
  {body: template});

export const updateTemplate = async (id, template) => API.post('eventmanagerAdminApi', `/events/${id}/templates`,
  {body: template});

export const deleteTemplate = async (event, template) =>
  API.del('eventmanagerAdminApi', `/events/${event.id}/templates/${template.id}`, {});

export const update = async (event) => API.post('eventmanagerAdminApi', `/events`, {body: event});

export const create = async (event) => API.put('eventmanagerAdminApi', `/events`, {body: event});

export const del = async (id) => API.del('eventmanagerAdminApi', `/events/${id}`, {});


export const sendGuestMail = async (id, templateId, guestId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/guest/${guestId}`, {});

export const sendAllGuestsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/all`, {});

export const sendHostMail = async (id, templateId, hostId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/host/${hostId}`, {});

export const sendAllHostsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/host`, {});

export const sendConfirmedGuestsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/confirmed`, {});

export const sendPendingGuestsMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/pending`, {});

export const sendTestMail = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/test`, {});

export const sendToMissingReplies = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/missing`, {});

export const sendToAllDenies = async (id, templateId) =>
  API.post('eventmanagerAdminApi', `/events/${id}/mail/${templateId}/denies`, {});
